export enum RecoverPinStatus {
  otp = 'otp',
  checkCard = 'check_card',
  setPin = 'set_pin',
  done = 'done',
}
